module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0